import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCurrentUserToken } from '../../utils/cookieUtils';
import { Host } from '../Apis';

// Base query with authentication
const baseQuery = fetchBaseQuery({
  baseUrl: Host,
  prepareHeaders: (headers, { getState }) => {
    // Get token from cookies
    const token = getCurrentUserToken();
    
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    
    // Don't set content-type here - let RTK Query handle it automatically
    // It will set the correct content-type based on the body type
    headers.set('accept', 'application/json');
    
    return headers;
  },
});

// Base query with reauth logic
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  
  // Handle "No available exams" response as success with empty data
  if (result.data && (result.data.message === "No available exams" || result.data.message === "No exams today")) {
    return {
      ...result,
      data: []
    };
  }
  
  // Handle 404 errors for examspage endpoint specifically
  if (result.error && result.error.status === 404 && args.url && (args.url.includes('/students/examspage') || args.url.includes('examspage'))) {
    // Check if it's a "no exams" 404 error
    if (result.error.data && (result.error.data.message === "No available exams" || result.error.data.message === "No exams today")) {
      return {
        data: [],
        meta: { request: args, response: result }
      };
    }
  }
  
  // Skip 401 handling for auth API endpoints
  const isAuthEndpoint = args.url && (
    args.url.includes('/api/v1/students/login') ||
    args.url.includes('/api/v1/adminlogin') ||
    args.url.includes('/api/v1/admin/stupass')
  );
  
  if (result.error && result.error.status === 401 && !isAuthEndpoint) {
    // Handle unauthorized access - clear cookies and redirect
    document.cookie = 'auth_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict';
    document.cookie = 'auth_tokena=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict';
    window.location.href = '/login';
  }
  
  return result;
};

// Main API slice
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Exam',
    'Student', 
    'Question',
    'Group',
    'Subject',
    'StudyYear',
    'Lecturer',
    'Result',
    'Followup',
    'ExamSchedule',
    'User',
    'Auth',
    'Answer',
    'ExamStats',
    'LecturerProfile',
    'LecturerSubjects',
    'LecturerStats'
  ],
  endpoints: (builder) => ({}),

});

export default apiSlice;
